<template>
  <div class="YiYing">
    <div class="container one-container">
      <div class="container-title">
        <div style="margin-right: 2.5rem"><span>亿</span>应俱全</div>
        <div>立竿见<span>影</span></div>
      </div>
      <div class="container-describe">亿影-数字人AIGC视频创作平台</div>
      <div class="container-label">
        <div>万级素材库</div>
        <div>傻瓜式操作</div>
        <div>广播级功能</div>
        <div>电影级效果</div>
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg1 two-container">
      <div class="container-title">AI快速生成</div>
      <div class="container-describe">
        基于最新大模型技术，自动生成动作场景，AI自动写稿
      </div>
      <div class="container-pic">
        <img :src="`${$CdnServerAddress}websit/web/video_pic1.png`" />
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg2 three-container">
      <div class="container-title">素材丰富</div>
      <div class="container-describe">
        系统内置100+数字人形象库，20+数字人灯光库，800+动作POSE库等辅助创作者进行海报和短视频的制作
      </div>
      <div class="container-pic">
        <YiyingMarquee
          :url="`${$CdnServerAddress}websit/web/video_pic2_1.png`"
          :step="-1"
        />
        <YiyingMarquee
          :url="`${$CdnServerAddress}websit/web/video_pic2_2.png`"
          :step="1"
        />
        <YiyingMarquee
          :url="`${$CdnServerAddress}websit/web/video_pic2_3.png`"
          :step="-1"
        />
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg1 four-container">
      <div class="container-title">动作融合</div>
      <div class="container-describe">
        自研动作融合算法，AI自动填补缺失帧生成不同动作之间的过渡融合，让数字人表演不生硬不间断，保证观感舒适
      </div>
      <div class="container-pic">
        <img :src="`${$CdnServerAddress}websit/web/video_pic3.png`" />
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg2 five-container">
      <div class="container-title">镜头切换</div>
      <div class="container-describe">
        通过镜头切换完成丰富有趣以及具有多样性的虚拟视频内容，产生出画面及声音的外在节奏满足不同用户的观感需求
      </div>
      <div class="container-pic">
        <img :src="`${$CdnServerAddress}websit/web/video_pic4.png`" />
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg2 six-container">
      <div class="container-title">精编细调</div>
      <div class="container-describe">
        用户可以对数字人动作进行自由拼接剪辑，通过WEB端渲染实现在线预览，精准匹配解说词及影片调性节奏
      </div>
      <div class="container-pic">
        <img :src="`${$CdnServerAddress}websit/web/video_pic5.png`" />
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/common/event-bus";
import YiyingMarquee from "@/components/yiyingMarquee/index.vue";

export default {
  name: "YiYingPage",
  components: {
    YiyingMarquee,
  },
  methods: {
    openApplyDialog() {
      EventBus.$emit("openApplyDialog", { type: 1 });
    },
    openContactDialog() {
      EventBus.$emit("openContactDialog");
    },
  },
};
</script>

<style lang="less" scoped>
.YiYing {
  width: 100%;
  position: relative;
  color: #ffffff;

  .container {
    width: 100%;
    min-height: calc(~"100vh - 64px");
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &.one-container {
      margin-top: 64px;
      background: url("https://bdbcdn.bdbdigital.com/websit/web/product2.png")
        center no-repeat #000000;
      background-size: cover;

      .container-title {
        font-size: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 8px;

        span {
          background: linear-gradient(
            180deg,
            #a6000d 0%,
            #b71a20 50%,
            #4f0023 100%
          );
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-size: 64px;
        }
      }

      .container-describe {
        font-size: 30px;
        margin-bottom: 40px;
        color: #ffffff;
      }
    }

    &.bg1 {
      background: url("https://bdbcdn.bdbdigital.com/websit/web/bg1.png") center
        no-repeat #000000;
      background-size: cover;
    }

    &.bg2 {
      background: url("https://bdbcdn.bdbdigital.com/websit/web/bg2.png") center
        no-repeat #000000;
      background-size: cover;
    }

    .container-title {
      font-size: 64px;
      font-weight: bold;
      margin-bottom: 40px;
    }

    .container-describe {
      font-size: 24px;
      margin-bottom: 40px;
      color: #bfbfbf;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .container-label {
      font-size: 18px;
      margin-bottom: 80px;
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .container-pic {
      width: 50%;
      margin-bottom: 40px;
      border-radius: 4px;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .container-btns {
      width: 320px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .btn {
        width: 134px;
        line-height: 38px;
        border: 1px solid #ffffff99;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
          background: #ffffff1a;
        }

        &.btn-apply {
          background: #a6000d;
          border-color: #a6000d;

          &:hover {
            background: #80000f;
            border-color: #80000f;
          }
        }

        .btn-icon {
          width: 16px;
          height: 16px;
          background: url("https://bdbcdn.bdbdigital.com/websit/web/arrow.svg")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>